<div class="modal-container" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">
  <div class="modal-content">
    <ng-content></ng-content>
  </div>
  <button class="btn btn-red center" (click)="closeModal($event)" *ngIf="showClose">{{closeText}}</button>
</div>
